/**
 * API client — calls the backend proxy which forwards to TfNSW.
 */
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

interface RequestOptions {
  params?: Record<string, string>;
  signal?: AbortSignal;
}

export async function apiGet<T = unknown>(path: string, options: RequestOptions = {}): Promise<T> {
  const url = new URL(path, API_URL);
  if (options.params) {
    for (const [key, value] of Object.entries(options.params)) {
      if (value !== undefined && value !== '') {
        url.searchParams.set(key, value);
      }
    }
  }

  const response = await fetch(url.toString(), {
    signal: options.signal,
  });

  if (!response.ok) {
    const text = await response.text().catch(() => 'Unknown error');
    throw new Error(`API error ${response.status}: ${text.slice(0, 200)}`);
  }

  return response.json();
}

export async function apiGetRaw(path: string, options: RequestOptions = {}): Promise<ArrayBuffer> {
  const url = new URL(path, API_URL);
  if (options.params) {
    for (const [key, value] of Object.entries(options.params)) {
      if (value !== undefined && value !== '') {
        url.searchParams.set(key, value);
      }
    }
  }

  const response = await fetch(url.toString(), {
    signal: options.signal,
  });

  if (!response.ok) {
    throw new Error(`API error ${response.status}`);
  }

  return response.arrayBuffer();
}
